import { render, staticRenderFns } from "./cog.vue?vue&type=template&id=cbafd490&scoped=true&"
import script from "./cog.vue?vue&type=script&lang=js&"
export * from "./cog.vue?vue&type=script&lang=js&"
import style0 from "./cog.vue?vue&type=style&index=0&id=cbafd490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbafd490",
  null
  
)

export default component.exports